/**
 * Description: Review section on review page for the Audit Tool. 
 */
import React from 'react';
import {
  Button
} from 'AWS-UI-Components-React';
import { JSClient } from '../common.jsx';
import { AuditedOutfits } from './auditedOutfits.jsx';
import '../../styles/browseSection.css';

export class BrowseSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user,
      filter_options: {},
      auditedOutfitsResult: [],
      tokens: [],
      token_number: 0
    };
    this.getAuditedOutfitsResultHandler = this.getAuditedOutfitsResultHandler.bind(this);
    this.getAuditedOutfitResultHandler = this.getAuditedOutfitResultHandler.bind(this);
    this.getAuditedOutfits = this.getAuditedOutfits.bind(this);
    this.storeNextToken = this.storeNextToken.bind(this);
    this.goToPage = this.goToPage.bind(this);
    this.postReAudit = this.postReAudit.bind(this);
    this.storeAuditBatch = this.storeAuditBatch.bind(this);
  }

  componentWillMount() {
    this.client = new JSClient();
  }

  getNewAuditedOutfits(filter_options) {
    this.setState((state, prop) => {
      return ({
        tokens: [""],
        filter_options: filter_options,
        token_number: 1
      });
    })
    return this.getAuditedOutfits();
  }

  // calls datastore get outfits base on filter options
  getAuditedOutfits() {
    if (this.state.filter_options.outfit_id) {
      return this.client.getOutfit(this.state.filter_options, this.getAuditedOutfitResultHandler);
    } else if (this.state.filter_options.marketplace == 0) {
      alert("Please select a marketplace.");
      return null
    } else {
      return this.client.getOutfits(this.state.filter_options, this.getAuditedOutfitsResultHandler);
    }
  }

  // get outfits result, store next token if exist and haven't been viewed before
  getAuditedOutfitsResultHandler(auditedOutfitsResult) {
    if (auditedOutfitsResult.next_token && this.state.token_number == this.state.tokens.length) {
      this.storeNextToken(auditedOutfitsResult.next_token);
    }
    this.setState({auditedOutfitsResult: auditedOutfitsResult.outfits});
  }

  // get ONE outfit result
  getAuditedOutfitResultHandler(auditedOutfit) {
    if (auditedOutfit) {
      this.setState({auditedOutfitsResult: [auditedOutfit]});
    } else {
      this.setState({auditedOutfitsResult: []});
    }
  }

  storeNextToken(next_token) {
    this.state.tokens.push(next_token);
  }

  goToPage(page_number) {
    this.state.token_number = page_number;
    this.state.filter_options.next_token = this.state.tokens[this.state.token_number - 1];
    this.getAuditedOutfits();
    this.refs.browse.scrollIntoView();
  }

  /**Updates auditedOutfitsResult based on re-audit status of an item*/
  storeAuditBatch(batchNum, audit_status, flag, rejection_reasons, itemNum) {
    this.state.auditedOutfitsResult[batchNum].items[itemNum].audit_status = audit_status;
    this.state.auditedOutfitsResult[batchNum].items[itemNum].rejection_reasons = rejection_reasons;
  }

  async postReAudit(batchNum, errorCallback) {
    const outfit = this.state.auditedOutfitsResult[batchNum];
    outfit.audit_user = this.state.user
    return this.client.postReAudit([outfit], errorCallback);
  }

  render() {
    /**Browse Content loads the audited outfits */
    const PageButtons = () => (
      <div id="page-buttons">
        <Button
          text="Prev Page" 
          variant="primary"
          disabled={this.state.token_number <= 1}
          onClick={e => {
            this.goToPage(this.state.token_number - 1);
            }
          }>
        </Button>
        Page: {this.state.token_number}
        <Button
          text="Next Page" 
          variant="primary"
          disabled={this.state.tokens.length <= this.state.token_number}
          onClick={e => {
            this.goToPage(this.state.token_number + 1);
            }
          }>
        </Button>
      </div>
    );

    const BrowseContent = () => (
      <div>
        <div>
          <PageButtons/>
          <AuditedOutfits 
          user={this.state.user}
          batch={this.state.auditedOutfitsResult} 
          storeAuditBatch={this.storeAuditBatch}
          saveReAudit={this.postReAudit} />
          <PageButtons/>
        </div>
      </div>
    );

    return (
      <div ref="browse">
        <BrowseContent/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/browsePage/browseSection.jsx